<div class="grids-container"
     [class.divider]="!showTitle"
     [style.grid-template-columns]="'repeat(' + blocks().length + ', minmax(0, 1fr))'"
     [style.grid-gap.px]="showTitle ? 0 : gapSize()">
  @for (block of blocks(); track block.hash) {
    @let link = (undefined | linkToUrl: block.link)[0];
    @if (block.showDialog || !link) {
      <button appFocusRemove class="block-item"
              (click)="onLinkClick(block.link, block.showDialog)">
        @if (showTitle) {
          <div class="block-container">
            <app-image-loading class="block-icon"
                               [clickable]="true"
                               [src]="block.hash"
                               [alt]="block.title"
                               [originalQuality]="false"
                               [targetHeight]="iconSize"
                               [targetWidth]="iconSize"/>
            <span class="title">{{block.title}}</span>
          </div>
        } @else {
          <app-image-loading [src]="block.hash"
                             [alt]="block.link"
                             [clickable]="true"
                             [originalQuality]="false"
                             [targetHeight]="imgHeight()"
                             [targetWidth]="imgWidth()"/>
        }
      </button>
    } @else if (windowService.isMobileDevice()) {
      <a class="center-container"
         [href]="link">
        <div class="block-container">
          <app-image-loading class="block-icon"
                             [clickable]="true"
                             [src]="block.hash"
                             [alt]="block.title"
                             [originalQuality]="false"
                             [targetHeight]="iconSize"
                             [targetWidth]="iconSize"/>
          <span class="title" [class.warn]="block.title === warnText">{{block.title}}</span>
        </div>
      </a>
    } @else {
      <a class="center-container block-item" target="_blank" [href]="link">
        <app-image-loading [src]="block.hash"
                           [alt]="block.link"
                           [clickable]="true"
                           [originalQuality]="false"
                           [targetHeight]="imgHeight()"
                           [targetWidth]="imgWidth()"/>
      </a>
    }
  }
</div>
